import React from "react";
import styled from "styled-components";
import {
    pickupColor,
    receiverColor,
    canceledColor,
    deliveredColor,
    returnedColor
} from "../../../../constants/constants";

const DotContainer = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const PrefixBadge = styled.div`
    position: absolute;
    top: -6px;
    left: -6px;
    width: 20px;
    height: 20px;
    font-size: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
    border-radius: 20px;
    border: 1px solid #000;
    font-weight: bold;
    color: #000;
    background: ${({prefixType, orderState}) => {
        if (prefixType === "pickup") {
            return pickupColor;
        }
        if (prefixType === "order") {
            if (orderState === "delivered") {
                return deliveredColor;
            }
            if (orderState === "canceled") {
                return canceledColor;
            }
            if (orderState === "returned") {
                return returnedColor;
            }
            return receiverColor;
        }
        return "transparent";
    }};
`;

const CustomDot = ({prefix, prefixType, orderState, status}) => {
    if (!prefix) {
        return <span className="ant-steps-icon-dot" />;
    }

    return (
        <DotContainer>
            <PrefixBadge prefixType={prefixType} orderState={orderState}>
                {prefix}
            </PrefixBadge>
            <span className="ant-steps-icon-dot" />
        </DotContainer>
    );
};

export default CustomDot;
